export default __webpack_public_path__ + "static/media/august-phlieger-CREqtqgBFcU-unsplash.49663962.jpg";